import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="bg-black py-8 px-4 text-center" data-id="element-56">
      <div className="max-w-4xl mx-auto" data-id="element-57">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-3" data-id="element-58">
          ¿Listo/a para transformar tu año en Psicología?
        </h2>
        <p className="text-xl text-gray-300 mb-5" data-id="element-59">
          Sumate a docentes que ya dejaron de improvisar.
        </p>

        <CTAButton href="https://checkout.kitonline.shop/cart/47657878585582:1" className="w-full md:w-auto px-12 py-5 text-xl" data-id="element-60">
          👉 QUIERO EMPEZAR AHORA
        </CTAButton>
      </div>
    </section>;
}